import { type QueryFunctionContext, useInfiniteQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import { apiClient } from '@services/apiClient';

import type {
  IEquipmentSettingsLogList,
  IUseEquipmentSettingsLogListKeys,
} from '../model/equipmentSettingsLogList';

export const equipmentSettingsLogListKey = (
  keys?: IUseEquipmentSettingsLogListKeys,
): [string, number, string] => ['equipmentSettingsLogList', keys?.perPage || 20, keys?.search || ''];

export const equipmentSettingsLogListFn = ({
  queryKey,
  pageParam = 1,
}: QueryFunctionContext<ReturnType<typeof equipmentSettingsLogListKey>, number>) =>
  apiClient
    .get(`${APP_API_URL}equipment-settings/log`, {
      params: { page: pageParam, per_page: queryKey[1], search: queryKey[2] },
    })
    .then(({ data }: AxiosResponse<IEquipmentSettingsLogList>) => data);

export const useEquipmentSettingsLogListInfiniteQuery = (keys: IUseEquipmentSettingsLogListKeys) => {
  return useInfiniteQuery({
    queryKey: equipmentSettingsLogListKey(keys),
    queryFn: equipmentSettingsLogListFn,
    getNextPageParam: ({ data, currentPage }) => (data?.length ? currentPage + 1 : undefined),
    keepPreviousData: true,
    refetchOnWindowFocus: false,
  });
};
